// console.log(`js/01-pageSections/instructors.js is working`);

const instructorCards = document.querySelectorAll(
  `.instructor:not(.instructor-no-bio)`
);

if (instructorCards) {
  for (let i = 0; i < instructorCards.length; i++) {
    instructorCards[i].addEventListener(`click`, checkCard);
  }
}

function checkCard() {
  let activeCard = this;
  console.log(activeCard);
  let readMore = this.querySelector(`.read-more`);
  /*
   * sets boolean value. If the click inside the card is also inside the readMore element, then it
   * will be set to true.
   */
  let checkWhereClick = readMore.contains(event.target);

  /**
   * The first if statement checks if the CSS class "card-active" is on the readmore element, which
   * is added by the enlargeCard function. If it does not contain the class, that means the card
   * is small and we need to enlarge the card. It allows the user to click anywhere in the card to
   * enlarge it.
   *
   * The else if checks if readMore element has the card-active classes, meaning the card is large
   * AND if the user clicks the readMore button (which now visually displays "show less"), then to
   * run the returnCard function and shrink it back down.
   */
  if (!readMore.classList.contains(`card-active`)) {
    enlargeCard(activeCard);
  } else if (readMore.classList.contains(`card-active`) && checkWhereClick) {
    returnCard(activeCard);
  }

  /**
   * Adding a function to the whole document to check where the user is clicking.
   */
  document.addEventListener(`click`, function () {
    checkClick(activeCard);
  });
}

/**
 *  @param {HTMLElement} card
 *
 * This function checks if the user is clicking outside of the card. If they are, it shrinks the
 * card back down
 */
function checkClick(card) {
  let isClickInside = card.contains(event.target);
  if (!isClickInside) {
    returnCard(card);
  }
}

/**
 * @param {HTMLElement} card
 *
 * This is the function that controls enlarging the card.
 */

function enlargeCard(card) {
  let cardNumber = card.getAttribute(`data-number`);
  let readMore = card.querySelector(`.read-more`);

  /**
   * Updating the readMore element to read "Show Less" and adding and removing appropriate CSS
   * classes
   */
  readMore.innerHTML = `Show Less`;
  card.classList.add(`instructor-active`);
  card.classList.remove(`return-instructor`);
  readMore.classList.add(`card-active`);

  /**
   * Adding the CSS classes that are used for viewports that have Instructor cards in three columns
   */
  if (cardNumber % 3 === 2) {
    card.classList.add(`middle-card-active`);
  } else if (cardNumber % 3 === 1) {
    card.classList.add(`left-card-active`);
  } else if (cardNumber % 3 === 0) {
    card.classList.add(`right-card-active`);
  }
}

/**
 * @param {HTMLElement} card
 *
 * The returnCard function undoes what the enlargeCard function did.
 */
function returnCard(card) {
  let readMore = card.querySelector(`.read-more`);
  let cardNumber = card.getAttribute(`data-number`);
  let bio = card.querySelector(`.instructor-bio`);

  /**
   * If the bio is long enough to warrent a scroll bar, this makes sure the biography scrolls back
   * up to the top when shrinking the card.
   */
  bio.scrollTop = 0;

  /**
   * Removing all CSS classes that are involved in showing a particular card is active.
   */
  card.classList.remove(`instructor-active`);
  readMore.classList.remove(`card-active`);
  if (cardNumber % 3 === 2) {
    card.classList.remove(`middle-card-active`);
  } else if (cardNumber % 3 === 1) {
    card.classList.remove(`left-card-active`);
  } else if (cardNumber % 3 === 0) {
    card.classList.remove(`right-card-active`);
  }

  /**
   * Adds the return-instructor CSS class which allows for the CSS animation that shrinks the card.
   */
  card.classList.add(`return-instructor`);

  /**
   * updating the readmore button to show "Read More" again.
   */
  readMore.innerHTML = `Read More`;
}
